import Badge from "@/components/Badge";

/**
 * The component for displaying the last login status.
 */
const LastLoginLabel = () => {
  return (
    <Badge className="absolute -top-5 -right-16" variant="default">
      ↵&nbsp;minule
    </Badge>
  );
};

export default LastLoginLabel;
